import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");
  const [amount, setAmount] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data.payment_status);
        setAmount(data.amount);
        if (data.payment_status === "paid") {
          refresh();
          return;
        }
      } catch (err) {
        console.error("Payment status poll failed:", err);
      }
      if (!cancelled && tries < 30) {
        setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [sessionId, tries, refresh]);

  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center">
      {status === "paid" ? (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-[#10B981]" strokeWidth={1.5} />
          <h1 className="font-heading font-black text-4xl tracking-tight mt-4" data-testid="payment-success-title">Top-up complete</h1>
          {amount != null && (
            <div className="font-mono font-bold text-5xl mt-3" data-testid="payment-success-amount">+${Number(amount).toFixed(2)}</div>
          )}
          <p className="text-zinc-700 mt-3">Your wallet has been credited. Go ready and start taking calls.</p>
          <Link to="/dashboard">
            <Button className="mt-8 btn-sharp bg-black hover:bg-zinc-800 text-white text-xs tracking-wider uppercase font-bold py-6 px-8" data-testid="payment-success-back-button">
              Back to dashboard
            </Button>
          </Link>
        </>
      ) : (
        <>
          <Loader2 className="w-16 h-16 mx-auto text-zinc-400 animate-spin" strokeWidth={1.5} />
          <h1 className="font-heading font-black text-4xl tracking-tight mt-4">Confirming payment…</h1>
          <p className="text-zinc-700 mt-3">Hang tight while we confirm the charge.</p>
        </>
      )}
    </div>
  );
}
